import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

const FILTERS = ['start', 'end', 'page', 'pageSize', 'view', 'sortOrder'] as const;
export type FilterName = (typeof FILTERS)[number];
export type SetFilterFn = (name: FilterName, value: string) => void;
export type RemoveFilterFn = (name: FilterName) => void;
export type FilterParams = Partial<{ [k in FilterName]: string }>;

dayjs.extend(timezone);

const today = dayjs().endOf('day');
const firstDayOfTheCurrentMonth = dayjs().startOf('month').format('YYYY-MM-DDTHH:mm:ss');
const useFilters = (): [FilterParams, SetFilterFn, RemoveFilterFn] => {
  const [searchParams, setSearchParams] = useSearchParams({
    end: today.format('YYYY-MM-DDTHH:mm:ss'),
    start: firstDayOfTheCurrentMonth,
    view: 'modality',
  });

  const filters = FILTERS.reduce((paramsObj, param) => {
    let value: string | null = null;

    if ((value = searchParams.get(param)) !== null) {
      paramsObj[param] = value ?? undefined;
    }

    return paramsObj;
  }, {} as FilterParams);

  function setFilter(name: string, value: string) {
    const existing: Record<string, string> = {};

    for (const [key, param] of searchParams.entries()) {
      existing[key] = param;
    }

    setSearchParams({ ...existing, [name]: value });
  }

  function removeFilter(name: string) {
    const existing: Record<string, string> = {};

    for (const [key, param] of searchParams.entries()) {
      if (key === name) {
        continue;
      }

      existing[key] = param;
    }

    setSearchParams({ ...existing });
  }

  return [filters, setFilter, removeFilter];
};

export default useFilters;
